<template>
  <v-container id="areprots" class="mt-13">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <div class="header d-flex flex-column align-center">
      <p class="mb-0">Reno Police Department</p>
      <p class="mb-0">Special Weapons & Tactics Team</p>
      <p class="">Reporting</p>
    </div>
    <hr />
    <div class="black--text">
      <p>
        Fill in the fields and click on search. Then, you can browse the search
        results and view or print each report. In search results, you may send
        all the data to one of the report types. If no criteria are selected,
        all the records will be returned, which may take a few minutes.
      </p>
    </div>
    <!-- Form -->
    <div id="full" class="full-form">
      <v-form id="full_form" ref="formIn">
        <!-- header-info -->
        <v-container>
          <v-row dense no-gutters>
            <v-col cols="12" md="12">
              <!-- viusible only on phones -->
              <div
                class="hide-if-large d-flex justify-space-around align-start"
              >
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Only Terms Below
                </div>
                <v-switch v-model="sterm.all" label=""></v-switch>
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Any terms Below
                </div>
              </div>
              <!-- visble on everything but phones -->
              <div class="hide-if-small d-flex justify-center align-start">
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Only Terms Below
                </div>
                <v-switch v-model="sterm.all" label=""></v-switch>
                <div style="margin-top: 21px; width: 135px; text-align: center">
                  Any terms Below
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="">
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-select
                class="mr-4"
                id="search_type"
                v-model="sterm.search_type"
                :items="['Please Choose', 'Training', 'After Action']"
                label="Search Type"
                aria-required="true"
                required
                attach
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-select
                v-if="sterm.search_type == 'After Action'"
                class="mr-4"
                id="risk-box1"
                v-model="sterm.rep_officer"
                :items="lst_aftact_users"
                label="By User"
                aria-required="true"
                attach
              ></v-select>
              <v-select
                v-if="sterm.search_type == 'Training'"
                class="mr-4"
                id="risk-box1"
                v-model="sterm.rep_officer"
                :items="lst_train_users"
                label="By User"
                aria-required="true"
                attach
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              @click="date_on"
              cols="12"
              scols="12"
              md="4"
              lg="4"
              v-if="!date_picker_show"
            >
              <v-text-field
                v-model="dateRangeText"
                label="Date range"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" v-if="date_picker_show">
              <div
                class="d-flex flex-column justify-center align-start"
                style="width: 292px; border: 1px solid black"
              >
                <v-date-picker v-model="sterm.dates" range></v-date-picker>
                <v-btn @click="close_date" class="blue--text" text>Close</v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                id="location"
                counter="60"
                maxlength="60"
                v-model="sterm.location"
                label="Location"
                ref="location"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                id="casenum"
                name="casenum"
                maxlength="60"
                counter="60"
                v-model="sterm.case_num"
                label=" Case #/SWAT #"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <v-select
                id="mission_type"
                v-model="sterm.mission_type"
                :items="['Warrant', 'QRF', 'DVP', 'HRT']"
                label="Mission Type"
                attach
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-select
                class=""
                id="nfdd"
                v-model="sterm.nfdd"
                :items="['n/a', 'Yes', 'No']"
                label="NFDD"
                attach
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-select
                class=""
                id="shots_fired"
                v-model="sterm.shots_fired"
                :items="['n/a', 'Yes', 'No']"
                label="Shots Fired"
                attach
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <div class="submit-btn mt-3 d-flex justify-center align-center">
        <v-btn color="primary" dark class="mb-2 mr-3" @click="search"
          >submit</v-btn
        >
        <v-btn color="primary" dark class="mb-2" @click="reset">reset</v-btn>
      </div>
    </div>
    <search_results
      :lst_search_results="lst_results"
      :update_search_results="update_search_results"
      :report_src="sterm.search_type"
    ></search_results>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.header p {
  font-size: 1.2em;
  font-weight: 400;
}
@media (min-width: 0px) {
  .hide-if-large {
    display: none !important;
  }
  .hide-if-small {
    display: flex !important;
  }
}
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
const search_results = () => import("../components/search_results.vue");

export default {
  name: "reports",
  mixins: [bus_common],
  components: { search_results },
  props: [],
  // data_reprot
  data() {
    return {
      update_search_results: null,
      lst_train_users: [],
      lst_aftact_users: [],
      date_picker_show: false,
      sterm_reset: {
        all: true,
        search_type: "After Action",
        dates: ["2024-11-1", "2024-11-30"],
        location: "Cafe",
        case_num: "99-12346",
        mission_type: "Warrant",
        nfdd: "",
        shots_fired: "",
        property_damage: "",
      },
      sterm: {
        all: true,
        search_type: "Please Choose",
        rep_officer: "",
        dates: [],
        location: "",
        case_num: "",
        mission_type: "",
        nfdd: "n/a",
        shots_fired: "n/a",
      },

      lst_results: [],
    };
  },
  computed: {
    dateRangeText() {
      return this.sterm.dates.join(" ~ ");
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    update_search_res() {
      this.update_search_results = new Date();
    },
    search() {
      console.log("search");
      this.lst_results = [];

      console.log("lst results: " + this.lst_results.length);
      this.update_search_res();
      this.show_loader(true);
      //validate
      if (
        this.sterm.search_type == "Please Choose" ||
        this.sterm.search_type == ""
      ) {
        this.swall_it(
          "Search Status",
          "Please select a Search Type.",
          "warning",
          null,
          null
        );
        return true;
      }
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sterm = this.mno(this.sterm);
      formIn.sterm.frm_date = this.sterm.dates[0];
      formIn.sterm.to_date = this.sterm.dates[1];

      formIn.apiname = "search";

      this.$store.commit("setSterm", formIn);

      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("d length: " + data.length);
          if (data.length == 0) {
            this.swall_it(
              "Search Status",
              "Unfortunately, your search didn't find any results. Please change your criteria and try again.",
              "warning",
              null,
              null
            );
          } else {
            self.lst_results = self.mno(data);
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    research() {
      //retrive and use the old sterm
      this.strem = this.mno(this.$store.state.sterm);
      let self = this;
      this.search(function () {
        //empty store copy of sterm if any
        let empt = {};
        self.$store.commit("setSterm", empt);
      });
    },
    reset() {
      this.sterm = this.mno(this.sterm_reset);
    },

    close_date() {
      this.date_picker_show = false;
    },
    date_change() {
      this.date_picker_show = false;
    },
    date_on() {
      this.date_picker_show = true;
    },
    get_users_aftact_rep() {
      this.show_loader(true);
      //validate

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_users_aftact_rep";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_aftact_users = self.mno(data);
          self.lst_aftact_users.unshift("n/a");
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error get_users_aftact_rep", msg, "error", null, null);
        });
    },
    get_users_train_rep() {
      this.show_loader(true);
      //validate

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_users_train_rep";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_train_users = self.mno(data);
          self.lst_train_users.unshift("n/a");
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error lst_train_users", msg, "error", null, null);
        });
    },
    highlight_link() {
      let lstlinks = document.querySelectorAll(".menulink");
      console.log("lengths: " + lstlinks.length);
      for (let index = 0; index < lstlinks.length; index++) {
        const element = lstlinks[index];
        element.style.color = "white";
      }
      document.getElementById("reportslink").style.color = "orange";
    },
    init() {
      // let old_sterm = this.$store.state.sterm;
      // if (JSON.stringify(old_sterm) === "{}") {
      //   this.research();
      // }
      this.get_users_train_rep();
      this.get_users_aftact_rep();
      let dt = new Date();
      let dt1 = dt.setDate(dt.getDate() + 1);
      this.sterm.dates.push(this.format_date_sql(dt));
      this.sterm.dates.push(this.format_date_sql(dt1));
    },
  },
  activated() {
    console.log("aftact Component is activated again!");
    this.highlight_link();
  },
  mounted() {
    this.$nextTick(() => {
      this.highlight_link();
      this.init();
    });
  },
};
</script>
